<div class="link" [class.remote]="!local()" [title]="template().config?.description || ''">
  @if (template().tag) {
    <a [routerLink]="['/tags', template().tag]">{{ template().name || template().tag }}</a>
  } @else {
    <a routerLink="/tags">{{ template().name || 'root' }}</a>
  }
  @if (!qualifiedTag()) {
    <span class="host" i18n>(root: "")</span>
  } @else if (!template().tag && template().origin) {
    <span class="host" i18n>(root: {{ template().origin }})</span>
  } @else if (template().name && template().tag) {
    <span class="host">({{ qualifiedTag() }})</span>
  } @else if (template().origin) {
    <span class="host">({{ template().origin }})</span>
  }
</div>
<div class="info">
  <span [title]="template().modified?.toISO()" i18n>modified {{ template().modified | relative }}</span>
  @if (!local()) {
    &nbsp;<span i18n>on</span>&nbsp;<a [routerLink]="['/tag', template().origin]">{{ template().origin }}</a>
  }
</div>
<div class="actions">
  @if (!created() && store.account.admin) {
    <app-confirm-action [action]="copy$" i18n>install</app-confirm-action>
  } @else if (!local()) {
    <app-inline-button [action]="copy$" i18n>copy</app-inline-button>
  }
  @if (created() && local() && store.account.admin) {
    <a class="fake-link" (click)="editing.set(!editing())" i18n>@if (editFormDirty()) {*edit*} @else {edit}</a>
  } @else {
    <a class="fake-link" (click)="viewSource.set(!viewSource())" i18n>source</a>
  }
  @if (canDiff()) {
    <a class="fake-link diff-link" (click)="toggleDiff()" i18n>diff</a>
  }
  <a class="fake-link" (click)="download()" i18n>download</a>
  @if (created() && store.account.admin) {
    <app-confirm-action [action]="delete$" i18n>delete</app-confirm-action>
  }
</div>

@if (editing()) {
  <form class="form" [formGroup]="editForm" (ngSubmit)="save()">

    <app-template-form [group]="editForm"
                       [configErrors]="configErrors()"
                       [defaultsErrors]="defaultsErrors()"
                       [schemaErrors]="schemaErrors()" />

    @for (e of serverError(); track e) {
      <span><!-- Unexpected Error --></span>
      <div class="error">{{ e }}</div>
    }

    <span><!-- Buttons --></span>
    <span class="buttons right floating">
      @if (saving()) {
        <app-loading [inline]="true" />
      }
      <button type="submit" [disabled]="saving() || submitted() && !editFormValid()" i18n>save</button>
      <button type="button" (click)="cancelEdit()" i18n>cancel</button>
    </span>
  </form>
} @else if (viewSource()) {
  <form class="form" [formGroup]="editForm">
    <app-template-form [group]="editForm" />
  </form>
} @else if (diffing() && diffLocal() && diffRemote()) {
  <div class="diff-view form">
    <app-diff #diffEditor
              [original]="diffLocal()!"
              [modified]="diffRemote()!"
              [readOnly]="!store.account.admin" />

    @for (e of serverError(); track e) {
      <span><!-- Unexpected Error --></span>
      <div class="error">{{ e }}</div>
    }

    <span><!-- Buttons --></span>
    <span class="buttons right floating">
      @if (saving()) {
        <app-loading [inline]="true" />
      }
      @if (store.account.admin) {
        <button type="button" class="save-diff" [disabled]="saving()" (click)="saveDiff()" i18n>save</button>
      }
      <button type="button" (click)="diffing.set(false)" i18n>cancel</button>
    </span>
  </div>
} @else {
  @for (e of serverError(); track e) {
    <div class="error">{{ e }}</div>
  }
}
